import React from 'react'
import './RowKey.css'

interface RowKeyProps {
    children: React.ReactNode,
    headers?: string,
    title?: string
}

function RowKey(props: RowKeyProps): JSX.Element {
  return (
    <td headers={props.headers} className='table-row-key' title={props.title}>{props.children}</td>
  )
}

export default RowKey